import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-gradient-to-b from-warmWhite to-teal-light pt-28 pb-16 px-4 md:px-8 overflow-hidden" data-id="element-136">
      <div className="max-w-7xl mx-auto" data-id="element-137">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-8" data-id="element-138">
          {/* Left Column - Text */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="w-full md:w-[60%] flex flex-col items-start" data-id="element-139">
            <div className="inline-block bg-teal/15 border border-teal rounded-full px-4 py-1.5 mb-6" data-id="element-140">
              <span className="text-[13px] text-teal font-semibold" data-id="element-141">
                Para mujeres hispanas de 40+
              </span>
            </div>

            <h1 className="text-[28px] md:text-[42px] font-extrabold text-dark leading-tight max-w-[680px]" data-id="element-142">
              Descubrí Por Qué las Mujeres Latinas de 40+ No Pueden Bajar la
              Panza... Y No Tiene <span className="text-teal" data-id="element-143">NADA</span> Que
              Ver Con Comer Menos o Ejercitarse Más
            </h1>

            <p className="text-[16px] md:text-[20px] text-[#555555] mt-5 font-normal leading-relaxed" data-id="element-144">
              La verdad que ningún médico, dietista ni influencer de fitness te
              ha dicho sobre lo que realmente detiene tu metabolismo después de
              los 40 — y el sistema de 15 minutos que lo revierte sin dietas de
              hambre, sin dejar tu comida favorita y sin pasar horas en el
              gimnasio.
            </p>

            <motion.a href="#final-cta" onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            document.getElementById('final-cta')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} className="mt-7 w-full md:w-auto bg-orange text-white text-[18px] font-bold py-[18px] px-[36px] rounded-lg shadow-[0_4px_15px_rgba(232,115,74,0.4)] hover:bg-[#d66239] transition-colors text-center inline-block cursor-pointer" data-id="element-145">
              SÍ, QUIERO MI REINICIO 40+ POR SOLO $6.36 →
            </motion.a>

            <div className="mt-4 w-full md:w-auto text-center flex flex-col items-center" data-id="element-146">
              <div className="flex items-center justify-center gap-2 text-[13px] text-[#888888]" data-id="element-147">
                <Lock size={14} data-id="element-148" /> Pago 100% Seguro • <Zap size={14} data-id="element-149" /> Acceso
                Inmediato • <ShieldCheck size={14} data-id="element-150" /> Garantía 7 Días
              </div>

              <div className="flex items-center justify-center gap-4 mt-4 opacity-60 grayscale" data-id="element-151">
                <span className="text-xs font-bold border border-gray-400 rounded px-2 py-1" data-id="element-152">
                  SSL Seguro
                </span>
                <span className="text-xs font-bold italic" data-id="element-153">PayPal</span>
                <span className="text-xs font-bold" data-id="element-154">VISA / MC</span>
                <span className="text-xs font-bold flex items-center gap-1" data-id="element-155">
                  <ShieldCheck size={12} data-id="element-156" /> Reembolso 7 días
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full md:w-[40%] relative flex justify-center items-center mt-8 md:mt-0" data-id="element-157">
            {/* Background Glow */}
            <div className="absolute w-[300px] h-[300px] bg-teal/20 rounded-full blur-[60px] -z-10" data-id="element-158"></div>

            <div className="relative w-full max-w-[450px]" data-id="element-159">
              {/* Floating Badges */}
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 4,
              ease: 'easeInOut'
            }} className="absolute -top-4 -left-4 md:-left-8 bg-white shadow-lg rounded-full px-4 py-2 text-sm font-bold text-teal z-20 border border-teal/10" data-id="element-160">
                50 páginas
              </motion.div>

              <motion.div animate={{
              y: [0, 10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 5,
              ease: 'easeInOut',
              delay: 1
            }} className="absolute -top-8 -right-4 md:-right-8 bg-white shadow-lg rounded-full px-4 py-2 text-sm font-bold text-orange z-20 border border-orange/10" data-id="element-161">
                Descarga Inmediata
              </motion.div>

              <motion.div animate={{
              y: [0, -8, 0]
            }} transition={{
              repeat: Infinity,
              duration: 4.5,
              ease: 'easeInOut',
              delay: 0.5
            }} className="absolute -bottom-4 left-4 bg-white shadow-lg rounded-full px-4 py-2 text-sm font-bold text-dark z-20 border border-gray-100" data-id="element-162">
                En Español
              </motion.div>

              <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} className="absolute -bottom-6 -right-4 bg-orange text-white shadow-xl rounded-full w-20 h-20 flex items-center justify-center text-center font-bold leading-tight z-20 border-4 border-white transform rotate-12" data-id="element-163">
                x6
                <br data-id="element-164" />
                PDFs
              </motion.div>

              {/* Main Product Image */}
              <img src="https://cdn.magicpatterns.com/uploads/8uYvHQ5tsib3scWLDa4447/pdf_principal_portada.png" alt="El Protocolo Reinicio 40+ en tablet y móvil" className="w-full h-auto object-contain drop-shadow-2xl relative z-10" data-id="element-165" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}